import { Link } from 'react-router-dom';
import EditIcon from '../../../../assets/icons/new_icon/edit-2.svg';
import { DataTable } from '../../../../components';
import { dateToUtc } from '../../../../functions';
import { getDashSeparatedDate } from '../../../fuctions';
import { JobSummary } from '../../interfaces';
import { IconButton, PriorityChip, StatusChip } from '../';
interface Props {
  jobSummaryList: JobSummary[];
  loadingJobSummaries: boolean;
  page: number;
  onChangePage: (page: number) => void;
  pageSize: number;
  onChangePageSize: (size: number) => void;
  count: number;
  pages: number;
  onClickEdit: (id: number) => void;
}

export default function JobSummaryDataTable({
  jobSummaryList,
  loadingJobSummaries,
  page,
  onChangePage,
  pageSize,
  onChangePageSize,
  count,
  pages,
  onClickEdit,
}: Props) {
  const headers = [
    {
      key: 'purchaseOrder',
      text: 'PO # (ref1)',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'vendor',
      text: 'Vendor',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'description',
      text: 'Description',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'priorityName',
      text: 'Priority',
      getCellContent: (priorityName: string) => (
        <PriorityChip priorityName={priorityName} />
      ),
    },
    {
      key: 'totalWeight',
      text: 'Total Weight',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'totalShipments',
      text: 'Total Loads',
      getCellContent: (value: number) => value,
    },
    {
      key: 'initialPlannedPickupDate',
      text: 'Initial Planned Pickup Date',
      getCellContent: (value: string) =>
        getDashSeparatedDate(dateToUtc(new Date(value))),
      noWrap: true,
    },
    {
      key: 'revisedPickupDate',
      text: 'Revised Pickup Date',
      getCellContent: (value: string) =>
        getDashSeparatedDate(dateToUtc(new Date(value))),
      noWrap: true,
    },
    {
      key: 'actualPickupDate',
      text: 'Actual Pickup Date',
      getCellContent: (value: string) =>
        getDashSeparatedDate(dateToUtc(new Date(value))),
      noWrap: true,
    },
    {
      key: 'handoffLocation',
      text: 'KBX Handoff Location',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'initialPlannedStagingDate',
      text: 'Initial Planned Staging Date',
      getCellContent: (value: string) =>
        getDashSeparatedDate(dateToUtc(new Date(value))),
      noWrap: true,
    },
    {
      key: 'revisedStagingDate',
      text: 'Revised Staging Date',
      getCellContent: (value: string) =>
        getDashSeparatedDate(dateToUtc(new Date(value))),
      noWrap: true,
    },
    {
      key: 'travelModeName',
      text: 'Travel Mode',
      getCellContent: (value: string) => value || 'N/A',
      noWrap: true,
    },
    {
      key: 'statusName',
      text: 'Status',
      getCellContent: (statusName: string) => (
        <StatusChip statusName={statusName} />
      ),
    },
    {
      key: 'id',
      text: '',
      getCellContent: (id: number) => (
        <IconButton
          icon={EditIcon}
          onClick={() => {
            onClickEdit(id);
          }}
        />
      ),
    },
    {
      key: 'bbeNumber',
      text: '',
      getCellContent: (bbeNumber: string) => (
        <Link
          to={`/app/project/view_shipments?job_id=${bbeNumber}`}
          style={{
            color: '#25215f',
            fontWeight: 400,
          }}
        >
          Details
        </Link>
      ),
    },
  ];

  return (
    <div className='JobHistoryDataTable'>
      <DataTable
        headers={headers}
        data={jobSummaryList}
        loading={loadingJobSummaries}
        page={page}
        onChangePage={onChangePage}
        pageSize={pageSize}
        onChangePageSize={onChangePageSize}
        count={count}
        pages={pages}
      />
    </div>
  );
}
